import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=134135b2&"
import script from "./Avatar.vue?vue&type=script&lang=js&"
export * from "./Avatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('134135b2')) {
      api.createRecord('134135b2', component.options)
    } else {
      api.reload('134135b2', component.options)
    }
    module.hot.accept("./Avatar.vue?vue&type=template&id=134135b2&", function () {
      api.rerender('134135b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/avatar/Avatar.vue"
export default component.exports